import CLIENT from '../utils/CUP';

export const MODULE_NAME = 'BULK_ACTION_CONTROLLER';

function namespaced(name) {
    return MODULE_NAME + '.' + name;
}

const LOAD = namespaced('LOAD');
const LOAD_OK = namespaced('LOAD_OK');
const LOAD_FAIL = namespaced('LOAD_FAIL');

export const ACTION_TYPES = {
    LOAD,
    LOAD_OK,
    LOAD_FAIL
};

export const bulkActionReducer = (state = {
    data: undefined,
    loading: false,
    error: null,
}, action) => {
    switch (action.type) {
        case LOAD:
            return Object.assign({}, state, { loading: true, error: null });
        case LOAD_OK:
            return Object.assign({}, state, { data: action.response, loading: false, error: null });
        case LOAD_FAIL:
            return Object.assign({}, state, { data: undefined, loading: false, error: action.error });
        default:
            return state;
    }
};

export const API = {

    doBulkAction: (values, successCallback, failureCallback) => {
        return async (dispatch) => {
            dispatch({ type: LOAD });
            try {
                const response = await CLIENT.bulkAction(values);
                dispatch({ type: LOAD_OK, response })
                if (typeof successCallback === 'function') {
                    successCallback(response);
                }
            } catch (error) {
                dispatch({ type: LOAD_FAIL, error })
                if (typeof failureCallback === 'function') {
                    failureCallback(error);
                }
            }
        }
    }
};

export default API;
